var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNavCoin = function SvgNavCoin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "NavCoin_svg__bitcoin-(btc)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "NavCoin_svg__Vector",
    d: "M7.49998 6.98399H11.4038C12.2692 6.98399 12.9711 7.76284 12.9711 8.5513C12.9711 9.41669 12.2692 10.1186 11.4038 10.1186H7.49998V6.98399Z",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "NavCoin_svg__Vector_2",
    d: "M7.49998 10.109H11.9615C12.9519 10.109 13.75 10.8109 13.75 11.6763C13.75 12.5417 12.9519 13.2436 11.9615 13.2436H7.49998V10.109Z",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "NavCoin_svg__Vector_3",
    d: "M10.2308 13.234V14.8013",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "NavCoin_svg__Vector_4",
    d: "M8.27884 13.234V14.8013",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "NavCoin_svg__Vector_5",
    d: "M10.2308 5.41667V6.98398",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "NavCoin_svg__Vector_6",
    d: "M8.27884 5.41667V6.98398",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "NavCoin_svg__Vector_7",
    d: "M8.98077 6.98399H6.25",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "NavCoin_svg__Vector_8",
    d: "M8.98077 13.234H6.25",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "NavCoin_svg__Vector_9",
    d: "M18.3333 10C18.3333 14.6024 14.6024 18.3333 10 18.3333C5.39763 18.3333 1.66667 14.6024 1.66667 10C1.66667 5.39763 5.39763 1.66667 10 1.66667C14.6024 1.66667 18.3333 5.39763 18.3333 10Z",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    stroke: "currentColor",
    opacity: 0.5
  }))));
};
export default SvgNavCoin;